// Orders module API helpers.
import { api } from "@/lib/api";

export async function listOrders({ search = "", filter = "all", cursor = null, limit = 50 } = {}) {
  const { data } = await api.get("/orders/", {
    params: { search, filter, cursor: cursor || undefined, limit },
  });
  return data;
}

export async function getOrder(orderId) {
  const { data } = await api.get(`/orders/${encodeURIComponent(orderId)}`);
  return data;
}

export async function getOrderCustomer(orderId) {
  const { data } = await api.get(`/orders/${encodeURIComponent(orderId)}/customer`);
  return data;
}

export async function addNote(orderId, text) {
  const { data } = await api.post(`/orders/${encodeURIComponent(orderId)}/notes`, { text });
  return data;
}

export async function deleteNote(orderId, noteId) {
  await api.delete(`/orders/${encodeURIComponent(orderId)}/notes/${encodeURIComponent(noteId)}`);
}

export async function setInternalTags(orderId, tags) {
  const { data } = await api.put(`/orders/${encodeURIComponent(orderId)}/internal-tags`, { tags });
  return data;
}

export async function syncOrders(full = false, limit = 250) {
  const { data } = await api.post("/orders/sync", { full, limit });
  return data;
}

export async function markFulfilled(orderId) {
  const { data } = await api.post(`/orders/${encodeURIComponent(orderId)}/fulfill`);
  return data;
}

export async function getSyncStatus() {
  const { data } = await api.get("/orders/sync/status");
  return data;
}
